/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, themeV2 } from '@insticator/insticator-ui'; // iui-utils

/* ++++++++++ --------------- EXPORT : DELETE USER : STYLES --------------- ++++++++++ */
export default theme =>({
  deleteuser: {
    extend: theme.modal.form,
    maxWidth: pxToEm(640),
    padding: `${pxToEm(8)} ${pxToEm(16)}`,
    '& .name-deleteuser':{
      '& .bodycopy':{
        marginTop:pxToEm(48),
        marginBottom: pxToEm(24),
        textAlign: 'center'
      },
      '& .deletemessage': {
        color: themeV2.color.base.gray.secondary,
        margin: `${pxToEm(20)} ${pxToEm(16)}`,
        textAlign: 'justify'
      },
      '& .toggle:nth-child(2)': {
        alignItems: 'flex-start',
        '& .radiospan': {
          marginTop: pxToEm(4)
        }
      }
    },
    '& .name-ctas':{
      marginTop:pxToEm(16)
    },
    '& .radio': {
      marginBottom: pxToEm(16),
      '& .radiospan': {
        width: pxToEm(20),
        height: pxToEm(20),
        margin: `0 ${pxToEm(20)}`,
        '&::after': {
          top: pxToEm(4),
          left: pxToEm(4),
          width: pxToEm(8),
          height: pxToEm(8)
        }
      },
      '& .text': {
        color: themeV2.color.base.gray.secondary,
        maxWidth: pxToEm(540),
        textAlign: 'justify'
      }
    },
    '& .usersdropdown': {
      width: '100%',
      padding: `0 ${pxToEm(8)}`,
      '& .name-menuItems': {
        maxHeight: pxToEm(240)
      },
      '& .search': {
        height: pxToEm(40)
      },
      '&.error-true': {
        '& .placeholder': {
          borderColor: themeV2.color.error.main
        }
      }
    },
    '& .name-sitespermissionmsg': {
      margin: `${pxToEm(20)} 0`
    },
    '& .errormessage': {
      opacity: '0',
      display: 'block',
      color: themeV2.color.error.main,
      fontSize: pxToEm(14),
      marginTop: pxToEm(5),
      // animate in 
      animationName: 'fadeInDown',
      animationDelay: '0s',
      animationDuration: '.1s',
      animationFillMode: 'forwards'
    }
  }
});
